module.exports = __webpack_public_path__ + "32cfda2c166d5520916df9339a699f2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/cashPay_inactive.png
// module id = 574
// module chunks = 0